// extracted by mini-css-extract-plugin
module.exports = {"features":"_aM","features__item":"_aN","card":"_aO","card__header":"_aP","card__image":"_aQ","card__title":"_aR","card__body":"_aS","card__link":"_aT","features__itemsGroup":"_aU"};